module.exports = __webpack_public_path__ + "static/img/blanco50_logo_zurqui.7ec97a96.png";